import { render, staticRenderFns } from "./DistribDoc.vue?vue&type=template&id=d1d9dbca&scoped=true"
import script from "./DistribDoc.vue?vue&type=script&lang=js"
export * from "./DistribDoc.vue?vue&type=script&lang=js"
import style0 from "./DistribDoc.vue?vue&type=style&index=0&id=d1d9dbca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d9dbca",
  null
  
)

export default component.exports